module.exports = require('./lib');



/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-datepicker/index.js
 ** module id = 117
 ** module chunks = 0
 **/